import Time from 'model/appointments/timeSlots/time'
import { isNil } from 'ramda'
import dayjs from 'dayjs'
import { SPECIFIC_TIME } from 'constants/appointments'

class SpecificTime extends Time {
  constructor(init) {
    super(init)
    // console.log('> SpecificTime constructor -', init)
    if (isNil(init)) return undefined
    this.__typename = init.__typename
  }

  // Potentially unused, moreover this field comes from BE
  get description() {
    const date = dayjs(this.date).format('dddd, MMM D, YYYY')
    return (
      this._description || `${date} | ${this.start_time} - ${this.end_time}`
    )
  }

  get display_kind() {
    return this._display_kind || 'Specific Time'
  }

  // Calculable
  get isRequested() {
    return (this.__typename || SPECIFIC_TIME) === SPECIFIC_TIME
  }

  get isSpecific() {
    return (this.__typename || SPECIFIC_TIME) === SPECIFIC_TIME
  }
}

export default SpecificTime
